import styled, { css } from "styled-components";
import { hw } from "features/homework/homeworkUi";

interface buttonProps {
    name: string;
    onButtonClick?: React.MouseEventHandler;
}

const Button = ({ name, onButtonClick }: buttonProps) => {
    return <Primary type="button" onClick={onButtonClick}>{name}</Primary>;
};

const ButtonDisabled = ({ name, onButtonClick }: buttonProps) => {
    return <Ghost type="button" onClick={onButtonClick}>{name}</Ghost>;
};

const TextButton = ({ name, onButtonClick }: buttonProps) => {
    return <Text type="button" onClick={onButtonClick}>{name}</Text>;
};

const ButtonReversed = ({ name, onButtonClick }: buttonProps) => {
    return <Outline type="button" onClick={onButtonClick}>{name}</Outline>;
};

const SmallButton = ({ name, onButtonClick }: buttonProps) => {
    return <Compact type="button" onClick={onButtonClick}>{name}</Compact>;
};

const ReleaseButton = ({ name, onButtonClick }: buttonProps) => {
    return <Primary type="button" onClick={onButtonClick}>{name}</Primary>;
};

const base = css`
    appearance: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 9px 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    cursor: pointer;
    white-space: nowrap;
    box-sizing: border-box;
`;

const Primary = styled.button`
    ${base}
    border: none;
    background: ${hw.brand};
    color: #fff;

    &:hover {
        background: ${hw.brandDark};
    }

    &:disabled {
        background: #CBD5E1;
        cursor: not-allowed;
    }
`;

const Ghost = styled.button`
    ${base}
    border: 1px solid ${hw.border};
    background: ${hw.surface};
    color: ${hw.textMuted};

    &:hover {
        background: ${hw.bg};
        color: ${hw.text};
    }
`;

const Outline = styled.button`
    ${base}
    border: 1px solid ${hw.brandMuted};
    background: ${hw.surface};
    color: ${hw.brand};

    &:hover {
        background: ${hw.brandSoft};
    }
`;

const Compact = styled.button`
    ${base}
    padding: 6px 10px;
    font-size: 12px;
    border: 1px solid ${hw.border};
    background: ${hw.surface};
    color: ${hw.textMuted};

    &:hover {
        background: ${hw.brandSoft};
        border-color: ${hw.brandMuted};
        color: ${hw.brand};
    }
`;

const Text = styled.button`
    ${base}
    padding: 8px 4px;
    border: none;
    background: none;
    color: ${hw.brand};

    &:hover {
        text-decoration: underline;
    }
`;

export { Button, ButtonDisabled, TextButton, ButtonReversed, SmallButton, ReleaseButton };
